/**
 * CarModal.jsx - 렌트카 신규/수정 모달 (Phase 3-C, 2026-04-30)
 */
import React, { useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import { validateReservationForm } from '../reservationFormValidation';
import { useReservationFieldSettings } from '../useReservationFieldSettings';
import { Field, Modal, Grid } from './_modal-helpers';

export default function CarModal({ travelCode, row, onClose, onSaved }) {
  const isNew = !row;
  const [form, setForm] = useState(row ? { ...row } : {});
  const [saving, setSaving] = useState(false);
  const { hiddenSet } = useReservationFieldSettings();
  const showField = (key) => !hiddenSet.has(key);
  const upd = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));

  async function handleSave() {
    const validationMessage = validateReservationForm({
      master: { travel_code: travelCode, customer_name: '-', reservation_date: '-' },
      flights: [],
      cars: [form],
      hotels: [],
      isVisible: showField,
    });
    if (validationMessage) { alert(validationMessage); return; }

    setSaving(true);
    try {
      const { notes, ...payload } = form;
      const r = isNew
        ? await apiClient.post(`/api/admin/reservations/${encodeURIComponent(travelCode)}/cars`, payload)
        : await apiClient.put(`/api/admin/car-rentals/${row.id}`, payload);
      if (r.ok && r.data?.success) { onSaved && onSaved(); onClose(); }
      else alert(r.data?.message || '저장 실패');
    } catch (e) { alert('오류: ' + e.message); }
    finally { setSaving(false); }
  }

  return (
    <Modal title={isNew ? '렌트카 추가' : `렌트카 수정 #${row.id}`} onClose={onClose} onSave={handleSave} saving={saving}>
      <Grid>
        {showField('car.total_cost') && <Field label="총액" required type="amount" value={form.total_cost} onChange={upd('total_cost')} />}
        {showField('car.rental_company') && <Field label="업체" value={form.rental_company} onChange={upd('rental_company')} />}
        {showField('car.car_model') && <Field label="차종" value={form.car_model} onChange={upd('car_model')} />}
        {showField('car.pickup_location') && <Field label="인수지" value={form.pickup_location} onChange={upd('pickup_location')} />}
        {showField('car.return_location') && <Field label="반납지" value={form.return_location} onChange={upd('return_location')} />}
        {showField('car.pickup_at') && <Field label="인수일시 (YYYY-MM-DD HH:mm)" value={form.pickup_at} onChange={upd('pickup_at')} />}
        {showField('car.return_at') && <Field label="반납일시 (YYYY-MM-DD HH:mm)" value={form.return_at} onChange={upd('return_at')} />}
        {showField('car.driver_name') && <Field label="운전자" value={form.driver_name} onChange={upd('driver_name')} />}
        {showField('car.insurance_type') && <Field label="보험 종류" value={form.insurance_type} onChange={upd('insurance_type')} />}
      </Grid>
    </Modal>
  );
}
